import EberCommon from './packages/common/index.js'
import EberUser from './packages/user/index.js'
import EberRecord from './packages/record/index.js'
import EberFollowup from './packages/followup/index.js'
import EberPatient from './packages/patient/index.js'
import EberAims from './packages/aims/index.js'
import EberDatabank from './packages/databank/index.js'
import EberCount from './packages/count/index.js'
import EberTemplate from './packages/template/index.js'

const components = [
  EberCommon.CommonFileList,
  EberCommon.CommonVnameItem,
  EberUser.UserDoctorInfo,
  EberRecord.RecordDoctorEdit,
  EberRecord.RecordImageList,
  EberRecord.RecordRecordImageList,
  EberRecord.RecordEdit,
  EberRecord.RecordConsultationEdit,
  EberRecord.RecordCourseEdit,
  EberRecord.RecordTransferEdit,
  EberRecord.RecordConsultationListComments,
  EberRecord.RecordCommentsList,
  EberRecord.RecordWindowCard,
  EberRecord.RecordWindowTable,
  EberRecord.RecordPatientRecord,
  EberRecord.RecordPatientRecordSelection,
  EberRecord.TimeLine,
  EberRecord.RecordTag,
  EberFollowup.FollowupEdit,
  EberFollowup.FollowupListEdit,
  EberFollowup.FollowupListComments,
  EberFollowup.FollowupRecord,
  EberFollowup.FollowupRecordList,
  EberFollowup.FollowupRecordEdit,
  EberPatient.PatientEdit,
  EberPatient.PatientSymptomWindow,
  EberPatient.PatientPotentialEdit,
  EberPatient.PatientSymptomEdit,
  EberPatient.SymptomImageList,
  EberAims.AimsArrangeList,
  EberAims.AimsArrangeTable,
  EberAims.AimsWaitList,
  EberAims.AimsOperationEdit,
  EberAims.AimsOperationSelection,
  EberAims.AimsOperationInfo,
  EberAims.AimsPrintList,
  EberAims.AimsSigningEdit,
  EberAims.AimsOperationBaseInfo,
  EberDatabank.DatabankNormcaseWindow,
  EberDatabank.DatabankNormcaseEdit,
  EberDatabank.DatabankNormcaseShow,
  EberDatabank.DatabankNormcaseParagraphEdit,
  EberDatabank.NormcaseCommentsList,
  EberCount.CountRecord,
  EberCount.CountRecordOutpatientTrend, // 门诊趋势
  EberCount.CountRecordInpatientTrend, // 门诊趋势
  EberCount.CountPosition, // 地域统计
  EberCount.CountPostitionTrend, // 地域趋势统计
  EberCount.CountOperationTrend, // 手术趋势统计
  EberCount.CountOperationSelf,
  EberCount.CountOperation,
  EberCount.CountAnaesthesia,
  EberCount.CountFollowup,
  EberCount.CountManage, // 经营情况
  EberCount.CountRevenue, // 营收统计
  EberCount.CountRevenueTrend, // 营收趋势
  EberCount.CountWorkload, // 个人工作量
  EberTemplate.TempFollowupListSelection,
  EberTemplate.TempFollowupPlanList,
  EberTemplate.TempFollowupEdit
]

const install = function (Vue) {
  components.map(component => {
    Vue.component(component.name, component)
  })
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  version: '1.0.1',
  name: 'EberComponents',
  install,
  CommonFileList: EberCommon.CommonFileList,
  CommonVnameItem: EberCommon.CommonVnameItem,
  UserDoctorInfo: EberUser.UserDoctorInfo,
  RecordDoctorEdit: EberRecord.RecordDoctorEdit,
  RecordImageList: EberRecord.RecordImageList,
  RecordRecordImageList: EberRecord.RecordRecordImageList,
  RecordEdit: EberRecord.RecordEdit,
  RecordConsultationEdit: EberRecord.RecordConsultationEdit,
  RecordCourseEdit: EberRecord.RecordCourseEdit,
  RecordTransferEdit: EberRecord.RecordTransferEdit,
  RecordConsultationListComments: EberRecord.RecordConsultationListComments,
  RecordCommentsList: EberRecord.RecordCommentsList,
  RecordWindowCard: EberRecord.RecordWindowCard,
  RecordWindowTable: EberRecord.RecordWindowTable,
  RecordPatientRecord: EberRecord.RecordPatientRecord,
  RecordPatientRecordSelection: EberRecord.RecordPatientRecordSelection,
  TimeLine: EberRecord.TimeLine,
  RecordTag: EberRecord.RecordTag,
  FollowupEdit: EberFollowup.FollowupEdit,
  FollowupListEdit: EberFollowup.FollowupListEdit,
  FollowupListComments: EberFollowup.FollowupListComments,
  FollowupRecord: EberFollowup.FollowupRecord,
  FollowupRecordList: EberFollowup.FollowupRecordList,
  FollowupRecordEdit: EberFollowup.FollowupRecordEdit,
  PatientEdit: EberPatient.PatientEdit,
  PatientSymptomWindow: EberPatient.PatientSymptomWindow,
  PatientPotentialEdit: EberPatient.PatientPotentialEdit,
  PatientSymptomEdit: EberPatient.PatientSymptomEdit,
  SymptomImageList: EberPatient.SymptomImageList,
  AimsArrangeList: EberAims.AimsArrangeList,
  AimsArrangeTable: EberAims.AimsArrangeTable,
  AimsWaitList: EberAims.AimsWaitList,
  AimsOperationEdit: EberAims.AimsOperationEdit,
  AimsOperationSelection: EberAims.AimsOperationSelection,
  AimsOperationInfo: EberAims.AimsOperationInfo,
  AimsPrintList: EberAims.AimsPrintList,
  AimsSigningEdit: EberAims.AimsSigningEdit,
  AimsOperationBaseInfo: EberAims.AimsOperationBaseInfo,
  DatabankNormcaseWindow: EberDatabank.DatabankNormcaseWindow,
  DatabankNormcaseEdit: EberDatabank.DatabankNormcaseEdit,
  DatabankNormcaseShow: EberDatabank.DatabankNormcaseShow,
  DatabankNormcaseParagraphEdit: EberDatabank.DatabankNormcaseParagraphEdit,
  NormcaseCommentsList: EberDatabank.NormcaseCommentsList,
  CountRecord: EberCount.CountRecord,
  CountRecordOutpatientTrend: EberCount.CountRecordOutpatientTrend,
  CountRecordInpatientTrend: EberCount.CountRecordInpatientTrend,
  CountPosition: EberCount.CountPosition,
  CountPostitionTrend: EberCount.CountPostitionTrend,
  CountOperationSelf: EberCount.CountOperationSelf,
  CountOperation: EberCount.CountOperation,
  CountAnaesthesia: EberCount.CountAnaesthesia,
  CountOperationTrend: EberCount.CountOperationTrend,
  CountFollowup: EberCount.CountFollowup,
  CountManage: EberCount.CountManage,
  CountRevenue: EberCount.CountRevenue,
  CountRevenueTrend: EberCount.CountRevenueTrend,
  TempFollowupListSelection: EberTemplate.TempFollowupListSelection,
  TempFollowupPlanList: EberTemplate.TempFollowupPlanList,
  TempFollowupEdit: EberTemplate.TempFollowupEdit
}
